"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NODE_TYPE = exports.INTERACTION_TYPE = exports.INTERACTION_TRIGGERS = exports.INTERACTION_STATUS = exports.FEATURE_NAME = exports.API_TRIGGER_NAME = void 0;
var _features = require("../../loaders/features/features");
const INTERACTION_TRIGGERS = exports.INTERACTION_TRIGGERS = ['click',
// e.g. user clicks link or the page back/forward buttons
'keydown',
// e.g. user presses left and right arrow key to switch between displayed photo gallery
'submit' // e.g. user clicks submit butotn or presses enter while editing a form field
];
const API_TRIGGER_NAME = exports.API_TRIGGER_NAME = 'api';
const FEATURE_NAME = exports.FEATURE_NAME = _features.FEATURE_NAMES.softNav;
const INTERACTION_TYPE = exports.INTERACTION_TYPE = {
  INITIAL_PAGE_LOAD: '',
  ROUTE_CHANGE: 1,
  UNSPECIFIED: 2
};
const NODE_TYPE = exports.NODE_TYPE = {
  INTERACTION: 1,
  AJAX: 2,
  CUSTOM_END: 3,
  CUSTOM_TRACER: 4
};
const INTERACTION_STATUS = exports.INTERACTION_STATUS = {
  IP: 'in progress',
  FIN: 'finished',
  CAN: 'cancelled'
};